/* eslint-disable no-unused-vars */
import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Listbox, Transition } from "@headlessui/react";
import { IoChevronDownSharp, IoClose } from "react-icons/io5";
import { HiChevronUpDown } from "react-icons/hi2";
import { InfoIcon2 } from "../../Assets/AllSvg";
import flagIndia from "../../Assets/flag-india.png";
import flagUSA from "../../Assets/Flag-Us.png";
import Countries from "../Json/Countries.json";
import Dialcode from "../Json/Dialcode.json";
import { CreateCustomer, UpdateCustomer } from "../API/CustomerAPI";
import { toast } from "react-toastify";
import { Auth } from "aws-amplify";
import { v4 as uuidv4 } from 'uuid';
import Languages from "../Json/Languages.json";

const TimeZone = [
  { name: "US - Central" },
  { name: "Africa - Abidjan" },
  { name: "Africa - Accra" },
  { name: "Africa - Addis Ababa" },
  { name: "Africa - Asmara" },
];

const Currency = [
  { name: "USD - US Dollar" },
  { name: "AFN - Afghan Afghani" },
  { name: "AOA - Angolan Kwanza" },
  { name: "BAM - Bosnia-Herzegovina Convertible Mark" },
  { name: "BIF - Burundian Franc" },
];

const texId = [
  { name: "India", avatar: flagIndia },
  { name: "USA", avatar: flagUSA },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const AddCustomerModel = ({ open, setOpen, custInfo }) => {
  const [addData, setAddData] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [selected, setSelected] = useState(Countries[0]);
  const [selected2, setSelected2] = useState(Countries[0]);
  const [addMore, setaddMore] = useState(false);
  const [addTime, setAddTime] = useState(TimeZone[0]);
  const [addLan, setAddLan] = useState({ name: 'English (United States)' });
  const [addCurrency, setAddCurrency] = useState(Currency[0]);
  const [active, setActive] = useState(false);
  const [removeData, setRemoveData] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [errMsg, setErrmsg] = useState("");
  const [userinfo, setUserInfo] = useState({
    check1: true,
    check2: true,
  });
  const [phone, setPhone] = useState({
    code1: "+1",
    code2: "+1",
  });
  const [customer, setCustomer] = useState("");
  const [billingDetails, setBillingDetails] = useState({
    country_name: "",
    address_one: "",
    address_two: "",
    city: "",
    phone_number: "",
    postal_code: "",
    state_name: "",
  });
  const [shippingdetails, setShippingdetails] = useState({
    name: "",
    address_one: "",
    address_two: "",
    city: "",
    phone_number: "",
    postal_code: "",
    state_name: "",
  });
  const [taxdetails, setTaxdetails] = useState([
    {
      text_idtext: '',
      taxt_idtype: '',
      taxt_id: texId[1],
    }
  ]);

  const handleAddCustomer = async () => {
    const billingData = {
      ...billingDetails,
      country_name:
        selected.country === "Choose a Country" ? "" : selected.country,
    };

    const shippingData = userinfo.check2
      ? {
        ...billingDetails,
        country_name:
          selected.country === "Choose a Country" ? "" : selected.country,
      }
      : {
        ...shippingdetails,
        country_name:
          selected2.country === "Choose a Country" ? "" : selected2.country,
      };

    const taxArr = []
    taxdetails.map((val) =>
      taxArr.push({ text_idtext: val.text_idtext, taxt_idtype: val.taxt_idtype === '' ? 'USA' : val.taxt_idtype })
    )

    if(custInfo){
      const postParams = {
        updateCustomerInput: {
          ...custInfo,
          name: customer.name,
          description: customer.description,
          account_email: customer.email,
          billing_email: customer.email,
          time_zone: addTime.name,
          invoice_prefix: customer.invoice,
          next_invoice: Number(customer.nextInvoice),
        },
      };

      const result = await UpdateCustomer(postParams)

      if (result) {
        setOpen(false);
        toast.success("Customer updated successfully", { autoClose: 5000 });
        setCustomer("");
      } else {
        toast.error("Something went wrong", { autoClose: 5000 });
      }
    } else {
      const postParams = {
        createCustomerInput: {
          client_id: localStorage.getItem("client_id"),
          user_id: localStorage.getItem("user"),
          customer_id: uuidv4(),
          name: customer.name,
          description: customer.description,
          account_email: customer.email,
          billing_email: customer.email,
          time_zone: addTime.name,
          invoice_prefix: customer.invoice,
          next_invoice: Number(customer.nextInvoice),
          inserted_dt: new Date().toISOString()
        },
      };

      if (customer === "") {
        setConfirm(true);
        setErrmsg("Please log in again to complete this action.");
      } else {
        if (errMsg !== "") {
          setConfirm(true);
        } else {
          const result = await CreateCustomer(postParams);
          if (result) {
            setOpen(false);
            toast.success("Customer added successfully", { autoClose: 5000 });
            setCustomer("");
          } else {
            toast.error("Something went wrong", { autoClose: 5000 });
          }
        }
      }

    }
  };

  const confirmPassword = async () => {
    const mail = localStorage.getItem("email");
    try {
      await Auth.signIn(mail, confirmPwd);
      toast.success("Your password is confirmed", { autoClose: 5000 });
      if (customer === "") {
        setConfirm(false);
        setErrmsg("");
      } else {
        const billingData = {
          ...billingDetails,
          country_name:
            selected.country === "Choose a Country" ? "" : selected.country,
        };

        const shippingData = userinfo.check2
          ? {
            ...billingDetails,
            country_name:
              selected.country === "Choose a Country" ? "" : selected.country,
          }
          : {
            ...shippingdetails,
            country_name:
              selected2.country === "Choose a Country"
                ? ""
                : selected2.country,
          };

        const taxArr = []
        taxdetails.map((val) =>
          taxArr.push({ text_idtext: val.text_idtext, taxt_idtype: val.taxt_idtype === '' ? 'USA' : val.taxt_idtype })
        )

        const postParams = {
          createCustomerInput: {
            client_id: localStorage.getItem("client_id"),
            user_id: localStorage.getItem("user"),
            customer_id: uuidv4(),
            name: customer.name,
            description: customer.description,
            account_email: customer.email,
            billing_email: customer.email,
            time_zone: addTime.name,
            invoice_prefix: customer.invoice,
            next_invoice: Number(customer.nextInvoice),
            inserted_dt: new Date().toISOString()
          },
        };

        setConfirm(false);
        setErrmsg("");

        const result = await CreateCustomer(postParams);
        if (result) {
          setOpen(false);
          toast.success("Customer added successfully", { autoClose: 5000 });
          setCustomer("");
        }
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 5000 });
    }
  };

  const handleCheckshipping = () => {
    setUserInfo({
      ...userinfo,
      check2: !userinfo.check2,
    });
  };

  const handleDeleteTax = (id) => {
    setTaxdetails(taxdetails.filter((val, i) => id !== i))
  }

  const handleonchangeTax = (val, i) => {
    const data = taxdetails.map((value, index) => {
      if (index === i) {
        value.text_idtext = val
      }
      return value
    })
    setTaxdetails(data)
  }

  const handleOnchangeCountry = (val, i) => {
    const data = taxdetails.map((value, index) => {
      if (index === i) {
        value.taxt_idtype = val.name
        value.taxt_id = val
      }
      return value
    })
    setTaxdetails(data)
  }

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const setCustomerData = () => {
    if(custInfo){
      setCustomer({
        name: custInfo.name,
        email: custInfo.account_email,
        description: custInfo.description,
        invoice: custInfo.invoice_prefix,
        nextInvoice: Number(custInfo.next_invoice)
      })

      setAddTime({name: custInfo.time_zone})
    }
  }

  useEffect(() => {
    setCustomerData()
  }, [open])
  

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-[#c1c9d2b3]" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-md">
                  <div>
                    <div className="font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">
                      {custInfo ? 'Update' : 'Create'} customer
                    </div>
                    <p className="text-red-600">{errMsg}</p>
                    <div className="sm:p-[16px_20px] p-[16px] max-h-[500px] h-full overflow-y-auto border-b-[1px] border-[#ebeef1] bg-[#fff]">
                      <span className="font-semibold text-base text-gray-900">
                        Account information
                      </span>
                      <div className="mt-5">
                        <span className="text-sm font-semibold">
                          Name *
                        </span>
                        <input
                          type="text"
                          placeholder="Jane Doe"
                          value={customer.name}
                          onChange={(e) =>
                            setCustomer({ ...customer, name: e.target.value })
                          }
                          className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                        />
                      </div>
                      <div className="mt-5">
                        <span className="text-sm font-semibold">
                          Account email *
                        </span>
                        <input
                          type="text"
                          placeholder="jane@example.com"
                          value={customer.email}
                          onChange={(e) =>
                            setCustomer({ ...customer, email: e.target.value })
                          }
                          className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                        />
                        <p className="text-red-600">
                          {customer.email !== undefined &&
                            customer.email !== "" &&
                            !isValidEmail(customer.email)
                            ? "Email is incorrect"
                            : ""}
                        </p>
                      </div>
                      <div className="mt-5">
                        <span className="text-sm font-semibold">
                          Description *
                        </span>
                        <input
                          type="text"
                          value={customer.description}
                          onChange={(e) => setCustomer({ ...customer, description: e.target.value, })}
                          className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                        />
                      </div>
                      <div
                        className="mt-5 cursor-pointer"
                        onClick={() => setAddData(!addData)}
                      >
                        <span className="flex items-center gap-2 font-semibold text-base text-gray-900">
                          Billing Information
                          <IoChevronDownSharp className="translate-y-[2px]" />
                        </span>
                      </div>
                      {addData && (
                        <div>
                          <div className="mt-5">
                            <div className="relative flex items-start">
                              <div className="flex h-6 items-center">
                                <input
                                  id="comments"
                                  name="comments"
                                  type="checkbox"
                                  className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                  value={userinfo.check1}
                                  checked={userinfo.check1}
                                  onChange={() =>
                                    setUserInfo({
                                      ...userinfo,
                                      check1: !userinfo.check1,
                                    })
                                  }
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label
                                  htmlFor="comments"
                                  className="select-none font-medium text-[#414552]"
                                >
                                  Same as account email
                                </label>
                              </div>
                            </div>
                          </div>
                          {!userinfo.check1 && (
                            <div>
                              <div className="mt-5">
                                <input
                                  type="text"
                                  placeholder="jane@example.com"
                                  className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                />
                                {!addMore && (
                                  <button
                                    onClick={() => setaddMore(true)}
                                    className="text-[#625afa] text-sm mt-5 font-semibold"
                                  >
                                    Add more recipients
                                  </button>
                                )}
                              </div>
                              {addMore && (
                                <div className="mt-5">
                                  <span className="text-sm text-[#414552] font-semibold">
                                    Emails To CC
                                  </span>
                                  <input
                                    type="text"
                                    placeholder="jane@example.com"
                                    className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                  />
                                </div>
                              )}
                            </div>
                          )}
                          <div className="mt-8">
                            <div className="flex items-center gap-2 text-[14px]">
                              <span className="text-sm text-[#414552] font-semibold">
                                Billing details
                              </span>
                              {selected.country ===
                                "Choose a Country" ? null : (
                                <div
                                  className="flex items-center gap-1 text-[#625afa] font-semibold cursor-pointer"
                                  onClick={() => {
                                    setRemoveData("1");
                                    setActive(true);
                                    setBillingDetails({});
                                  }}
                                >
                                  Remove <IoClose className="text-[20px]" />
                                </div>
                              )}
                            </div>
                            <Listbox value={selected} onChange={setSelected}>
                              {({ open }) => (
                                <>
                                  <div className="relative mt-1">
                                    <Listbox.Button className="relative w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                                      <span className="block truncate">
                                        {selected.country}
                                      </span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <HiChevronUpDown className="text-[20px]" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 text-base shadow-xl focus:outline-none sm:text-sm">
                                        {Countries.map((person, i) => (
                                          <Listbox.Option
                                            key={i}
                                            className={({ active }) =>
                                              classNames(
                                                active
                                                  ? "bg-[#f6f8fa]"
                                                  : "text-[#414552]",
                                                "relative cursor-default select-none py-2 pl-3 pr-9"
                                              )
                                            }
                                            value={person}
                                          >
                                            {({ selected, active }) => (
                                              <>
                                                <span
                                                  className={classNames(
                                                    selected
                                                      ? "font-semibold"
                                                      : "font-normal",
                                                    "block truncate"
                                                  )}
                                                >
                                                  {person.country}
                                                </span>

                                                {selected ? (
                                                  <span
                                                    className={classNames(
                                                      active
                                                        ? "text-white"
                                                        : "text-indigo-600",
                                                      "absolute inset-y-0 right-0 flex items-center pr-4"
                                                    )}
                                                  ></span>
                                                ) : null}
                                              </>
                                            )}
                                          </Listbox.Option>
                                        ))}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                            {selected.country === "Choose a Country" ? null : (
                              <div className="mt-3">
                                <input
                                  type="text"
                                  placeholder="Address line 1"
                                  onChange={(e) =>
                                    setBillingDetails({
                                      ...billingDetails,
                                      address_one: e.target.value,
                                    })
                                  }
                                  className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                />
                                <input
                                  type="text"
                                  placeholder="Address line 2"
                                  onChange={(e) =>
                                    setBillingDetails({
                                      ...billingDetails,
                                      address_two: e.target.value,
                                    })
                                  }
                                  className="mt-2 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                />
                                <input
                                  type="text"
                                  placeholder="City"
                                  onChange={(e) =>
                                    setBillingDetails({
                                      ...billingDetails,
                                      city: e.target.value,
                                    })
                                  }
                                  className="mt-2 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                />
                                <input
                                  type="number"
                                  placeholder="ZIP"
                                  onChange={(e) =>
                                    setBillingDetails({
                                      ...billingDetails,
                                      postal_code: e.target.value,
                                    })
                                  }
                                  className="mt-2 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                />
                                <div className="relative w-full mt-1">
                                  <select
                                    onChange={(e) =>
                                      setBillingDetails({
                                        ...billingDetails,
                                        state_name: e.target.value,
                                      })
                                    }
                                    className="mt-1 input_focus_shadow font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] appearance-none text-[14px]"
                                  >
                                    {selected.states.map((val, i) => <option key={i} value={val}>{val}</option>)}
                                  </select>
                                  <HiChevronUpDown className="text-[26px] absolute top-[7px] right-0 flex items-center pr-2" />
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="mt-5">
                            <div className="input_focus_shadow text-[#a3acba] font-normal h-[30px] w-full bg-white rounded-[6px] focus:outline-none text-[14px] flex items-center px-3">
                              <div className="relative text-[#404452]">
                                <select
                                  className="font-semibold focus:outline-none"
                                  onChange={(e) =>
                                    setPhone({
                                      ...phone,
                                      code1: e.target.value,
                                    })
                                  }
                                >
                                  {Dialcode.map((val, i) => (
                                    <option value={val.dial_code} key={i}>
                                      {val.code}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="text-[#404452]">
                                {phone.code1}
                              </div>
                              <div>
                                <input
                                  type="number"
                                  onChange={(e) =>
                                    setBillingDetails({
                                      ...billingDetails,
                                      phone_number: e.target.value,
                                    })
                                  }
                                  className="text-[#a3acba] font-normal px-3 w-full focus:outline-none h-[30px] text-[14px]"
                                  placeholder="5521 33653"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mt-8">
                            <span className="text-sm text-[#414552] font-semibold">
                              Shipping details
                            </span>
                            <div className="relative flex items-start mt-2">
                              <div className="flex h-6 items-center">
                                <input
                                  id="bill"
                                  name="billing-details"
                                  type="checkbox"
                                  className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none"
                                  value={userinfo.check2}
                                  checked={userinfo.check2}
                                  onChange={handleCheckshipping}
                                />
                              </div>
                              <div className="ml-3 text-sm leading-6">
                                <label
                                  htmlFor="bill"
                                  className="select-none font-medium text-[#414552]"
                                >
                                  Same as billing details
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="mt-4">
                            {!userinfo.check2 && (
                              <div>
                                <input
                                  type="text"
                                  placeholder="Jane Doe"
                                  onChange={(e) =>
                                    setShippingdetails({
                                      ...shippingdetails,
                                      name: e.target.value,
                                    })
                                  }
                                  className="mt-1 mb-2 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                />
                                <div className="flex justify-end items-center text-[14px]">
                                  {selected2.country ===
                                    "Choose a Country" ? null : (
                                    <div
                                      className="flex items-center gap-1 mb-[-10px] text-[#625afa] font-semibold cursor-pointer"
                                      onClick={() => {
                                        setRemoveData("2");
                                        setActive(true);
                                        setShippingdetails({});
                                      }}
                                    >
                                      Remove <IoClose className="text-[20px]" />
                                    </div>
                                  )}
                                </div>
                                <Listbox
                                  value={selected2}
                                  onChange={setSelected2}
                                >
                                  {({ open }) => (
                                    <>
                                      <div className="relative mt-4">
                                        <Listbox.Button className="relative w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                                          <span className="block truncate">
                                            {selected2.country}
                                          </span>
                                          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <HiChevronUpDown className="text-[20px]" />
                                          </span>
                                        </Listbox.Button>

                                        <Transition
                                          show={open}
                                          as={Fragment}
                                          leave="transition ease-in duration-100"
                                          leaveFrom="opacity-100"
                                          leaveTo="opacity-0"
                                        >
                                          <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 text-base shadow-xl focus:outline-none sm:text-sm">
                                            {Countries.map((person, i) => (
                                              <Listbox.Option
                                                key={i}
                                                className={({ active }) =>
                                                  classNames(
                                                    active
                                                      ? "bg-[#f6f8fa]"
                                                      : "text-[#414552]",
                                                    "relative cursor-default select-none py-2 pl-3 pr-9"
                                                  )
                                                }
                                                value={person}
                                              >
                                                {({ selected2, active }) => (
                                                  <>
                                                    <span
                                                      className={classNames(
                                                        selected2
                                                          ? "font-semibold"
                                                          : "font-normal",
                                                        "block truncate"
                                                      )}
                                                    >
                                                      {person.country}
                                                    </span>

                                                    {selected2 ? (
                                                      <span
                                                        className={classNames(
                                                          active
                                                            ? "text-white"
                                                            : "text-indigo-600",
                                                          "absolute inset-y-0 right-0 flex items-center pr-4"
                                                        )}
                                                      ></span>
                                                    ) : null}
                                                  </>
                                                )}
                                              </Listbox.Option>
                                            ))}
                                          </Listbox.Options>
                                        </Transition>
                                      </div>
                                    </>
                                  )}
                                </Listbox>

                                {selected2.country ===
                                  "Choose a Country" ? null : (
                                  <div className="mt-3">
                                    <input
                                      type="text"
                                      placeholder="Address line 1"
                                      onChange={(e) =>
                                        setShippingdetails({
                                          ...shippingdetails,
                                          address_one: e.target.value,
                                        })
                                      }
                                      className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                    />
                                    <input
                                      type="text"
                                      placeholder="Address line 2"
                                      onChange={(e) =>
                                        setShippingdetails({
                                          ...shippingdetails,
                                          address_two: e.target.value,
                                        })
                                      }
                                      className="mt-2 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                    />
                                    <input
                                      type="text"
                                      placeholder="City"
                                      onChange={(e) =>
                                        setShippingdetails({
                                          ...shippingdetails,
                                          city: e.target.value,
                                        })
                                      }
                                      className="mt-2 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                    />
                                    <input
                                      type="number"
                                      placeholder="ZIP"
                                      onChange={(e) =>
                                        setShippingdetails({
                                          ...shippingdetails,
                                          postal_code: e.target.value,
                                        })
                                      }
                                      className="mt-2 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                    />
                                    <div className="relative w-full mt-1">
                                      <select
                                        onChange={(e) =>
                                          setShippingdetails({
                                            ...shippingdetails,
                                            state_name: e.target.value,
                                          })
                                        }
                                        className="mt-1 input_focus_shadow font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] appearance-none text-[14px]"
                                      >
                                        {selected2.states.map((val, i) => <option key={i} value={val}>{val}</option>)}
                                      </select>
                                      <HiChevronUpDown className="text-[26px] absolute top-[7px] right-0 flex items-center pr-2" />
                                    </div>
                                  </div>
                                )}
                                <div className="input_focus_shadow text-[#a3acba] mt-4 font-normal h-[30px] w-full bg-white rounded-[6px] focus:outline-none text-[14px] flex items-center px-3">
                                  <div className="relative text-[#404452]">
                                    <select
                                      className="font-semibold focus:outline-none"
                                      onChange={(e) =>
                                        setPhone({
                                          ...phone,
                                          code2: e.target.value,
                                        })
                                      }
                                    >
                                      {Dialcode.map((val, i) => (
                                        <option value={val.dial_code} key={i}>
                                          {val.code}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  <div className="text-[#404452]">
                                    {phone.code2}
                                  </div>
                                  <div>
                                    <input
                                      type="number"
                                      onChange={(e) =>
                                        setShippingdetails({
                                          ...shippingdetails,
                                          phone_number: e.target.value,
                                        })
                                      }
                                      className="text-[#a3acba] font-normal px-3 w-full focus:outline-none h-[30px] text-[14px]"
                                      placeholder="5521 33653"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="mt-7">
                            <span className="text-sm text-[#414552] font-semibold">
                              Time zone
                            </span>
                            <Listbox value={addTime} onChange={setAddTime}>
                              {({ open }) => (
                                <>
                                  <div className="relative mt-1">
                                    <Listbox.Button className="relative w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                                      <span className="block truncate">
                                        {addTime.name}
                                      </span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <HiChevronUpDown className="text-[20px]" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 text-base shadow-xl focus:outline-none sm:text-sm">
                                        {TimeZone.map((person, i) => (
                                          <Listbox.Option
                                            key={i}
                                            className={({ active }) =>
                                              classNames(
                                                active
                                                  ? "bg-[#f6f8fa]"
                                                  : "text-[#414552]",
                                                "relative cursor-default select-none py-2 pl-3 pr-9"
                                              )
                                            }
                                            value={person}
                                          >
                                            {({ addTime, active }) => (
                                              <>
                                                <span
                                                  className={classNames(
                                                    addTime
                                                      ? "font-semibold"
                                                      : "font-normal",
                                                    "block truncate"
                                                  )}
                                                >
                                                  {person.name}
                                                </span>

                                                {addTime ? (
                                                  <span
                                                    className={classNames(
                                                      active
                                                        ? "text-white"
                                                        : "text-indigo-600",
                                                      "absolute inset-y-0 right-0 flex items-center pr-4"
                                                    )}
                                                  ></span>
                                                ) : null}
                                              </>
                                            )}
                                          </Listbox.Option>
                                        ))}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                          </div>
                          <div className="mt-7">
                            <span className="text-sm text-[#414552] font-semibold">
                              Language
                            </span>
                            <Listbox value={addLan} onChange={setAddLan}>
                              {({ open }) => (
                                <>
                                  <div className="relative mt-1">
                                    <Listbox.Button className="relative w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                                      <span className="block truncate">
                                        {addLan.name}
                                      </span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <HiChevronUpDown className="text-[20px]" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 text-base shadow-xl focus:outline-none sm:text-sm">
                                        {Languages.map((person, i) => (
                                          <Listbox.Option
                                            key={i}
                                            className={({ active }) =>
                                              classNames(
                                                active
                                                  ? "bg-[#f6f8fa]"
                                                  : "text-[#414552]",
                                                "relative cursor-default select-none py-2 pl-3 pr-9"
                                              )
                                            }
                                            value={person}
                                          >
                                            {({ addLan, active }) => (
                                              <>
                                                <span
                                                  className={classNames(
                                                    addLan
                                                      ? "font-semibold"
                                                      : "font-normal",
                                                    "block truncate"
                                                  )}
                                                >
                                                  {person.name}
                                                </span>

                                                {addLan ? (
                                                  <span
                                                    className={classNames(
                                                      active
                                                        ? "text-white"
                                                        : "text-indigo-600",
                                                      "absolute inset-y-0 right-0 flex items-center pr-4"
                                                    )}
                                                  ></span>
                                                ) : null}
                                              </>
                                            )}
                                          </Listbox.Option>
                                        ))}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                          </div>
                          <div className="mt-7">
                            <span className="text-sm text-[#414552] font-semibold">
                              Currency
                            </span>
                            <Listbox
                              value={addCurrency}
                              onChange={setAddCurrency}
                            >
                              {({ open }) => (
                                <>
                                  <div className="relative mt-1">
                                    <Listbox.Button className="relative w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                                      <span className="block truncate">
                                        {addCurrency.name}
                                      </span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <HiChevronUpDown className="text-[20px]" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 text-base shadow-xl focus:outline-none sm:text-sm">
                                        {Currency.map((person, i) => (
                                          <Listbox.Option
                                            key={i}
                                            className={({ active }) =>
                                              classNames(
                                                active
                                                  ? "bg-[#f6f8fa]"
                                                  : "text-[#414552]",
                                                "relative cursor-default select-none py-2 pl-3 pr-9"
                                              )
                                            }
                                            value={person}
                                          >
                                            {({ addCurrency, active }) => (
                                              <>
                                                <span
                                                  className={classNames(
                                                    addCurrency
                                                      ? "font-semibold"
                                                      : "font-normal",
                                                    "block truncate"
                                                  )}
                                                >
                                                  {person.name}
                                                </span>

                                                {addCurrency ? (
                                                  <span
                                                    className={classNames(
                                                      active
                                                        ? "text-white"
                                                        : "text-indigo-600",
                                                      "absolute inset-y-0 right-0 flex items-center pr-4"
                                                    )}
                                                  ></span>
                                                ) : null}
                                              </>
                                            )}
                                          </Listbox.Option>
                                        ))}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                          </div>
                          <div className="mt-7">
                            <span className="text-sm text-[#414552] font-semibold flex items-center gap-2">
                              Invoice prefix
                              <InfoIcon2 />
                            </span>
                            <input
                              type="text"
                              value={customer.invoice}
                              onChange={(e) => setCustomer({ ...customer, invoice: e.target.value })}
                              className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                            />
                          </div>
                          <div className="mt-7">
                            <span className="text-sm text-[#414552] font-semibold flex items-center gap-2">
                              Next invoice sequence
                              <InfoIcon2 />
                            </span>
                            <input
                              type="number"
                              defaultValue="1"
                              value={customer.nextInvoice}
                              onChange={(e) => setCustomer({ ...customer, nextInvoice: e.target.value })}
                              className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                            />
                          </div>
                          <div className="mt-7">
                            <span className="text-sm text-[#414552] font-semibold">
                              {" "}
                              Tax status
                            </span>
                            <div className="text-sm text-[#414552]">
                              <span className="font-semibold text-[#625afa]">
                                Review our guide
                              </span>{" "}
                              on tax statuses to select the best fit for your
                              customer.
                            </div>
                            <div className="relative text-[#404452]">
                              <select
                                onChange={(e) => setCustomer({ ...customer, taxStatus: e.target.value })}
                                className="mt-1 input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px] appearance-none"
                              >
                                <option value="Texable">Taxable</option>
                                <option value="Exampt">Exampt</option>
                                <option value="Reverse Charge">
                                  Reverse Charge
                                </option>
                              </select>
                              <HiChevronUpDown className="absolute top-[5px] right-0 flex items-center pr-2 text-[30px]" />
                            </div>
                          </div>
                          <div className="mt-7">
                            <span className="text-sm text-[#414552] font-semibold">
                              Tax ID
                            </span>
                            {taxdetails.map((val, indx) =>
                              <div key={indx} className="mt-1 flex gap-2 items-center">
                                <Listbox value={val.taxt_id} onChange={(e) => handleOnchangeCountry(e, indx)}>
                                  {({ open }) => (
                                    <>
                                      <div className="relative mt-1 w-full">
                                        <Listbox.Button className="relative w-full rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none sm:text-sm sm:leading-6">
                                          <div className="flex gap-2 items-center">
                                            <img
                                              src={val.taxt_id.avatar}
                                              className="w-[25px]"
                                              alt=""
                                            />
                                            <span className="block truncate font-semibold">
                                              {val.taxt_id.name}
                                            </span>
                                          </div>
                                          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                            <HiChevronUpDown className="text-[20px]" />
                                          </span>
                                        </Listbox.Button>

                                        <Transition
                                          show={open}
                                          as={Fragment}
                                          leave="transition ease-in duration-100"
                                          leaveFrom="opacity-100"
                                          leaveTo="opacity-0"
                                        >
                                          <Listbox.Options className="absolute z-[100] mt-1 max-h-60 w-full overflow-auto rounded-md bg-white border-[1px] border-gray-300 py-1 text-base shadow-xl focus:outline-none sm:text-sm">
                                            {texId.map((person, i) => (
                                              <Listbox.Option
                                                key={i}
                                                className={({ active }) =>
                                                  classNames(
                                                    active
                                                      ? "bg-[#f6f8fa]"
                                                      : "text-[#414552]",
                                                    "relative cursor-default select-none py-2 pl-3 pr-9"
                                                  )
                                                }
                                                value={person}
                                              >
                                                {({ active }) => (
                                                  <>
                                                    <div className="flex gap-2 items-center">
                                                      <img
                                                        src={person.avatar}
                                                        className="w-[25px]"
                                                        alt=""
                                                      />
                                                      <span
                                                        className={classNames(
                                                          val.taxt_id
                                                            ? "font-semibold"
                                                            : "font-normal",
                                                          "block truncate"
                                                        )}
                                                      >
                                                        {person.name}
                                                      </span>
                                                    </div>

                                                    {val.taxt_id ? (
                                                      <span
                                                        className={classNames(
                                                          active
                                                            ? "text-white"
                                                            : "text-indigo-600",
                                                          "absolute inset-y-0 right-0 flex items-center pr-4"
                                                        )}
                                                      ></span>
                                                    ) : null}
                                                  </>
                                                )}
                                              </Listbox.Option>
                                            ))}
                                          </Listbox.Options>
                                        </Transition>
                                      </div>
                                    </>
                                  )}
                                </Listbox>
                                <input
                                  type="number"
                                  placeholder="12314598898"
                                  value={val.text_idtext}
                                  onChange={(e) => handleonchangeTax(e.target.value, indx)}
                                  className="mt-1 input_focus_shadow text-[#a3acba] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]"
                                />
                                <button onClick={() => handleDeleteTax(indx)}>
                                  <IoClose className="text-[#8d7ffa]" />
                                </button>
                              </div>
                            )}
                          </div>
                          <div className="mt-2">
                            <button
                              onClick={() => setTaxdetails([...taxdetails, {
                                text_idtext: '',
                                taxt_idtype: '',
                                taxt_id: texId[1],
                              }])}
                              className="text-[#625afa] text-sm font-semibold">
                              Add another ID
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                      <button
                        className="border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-semibold p-[0_8px]"
                        onClick={() => setOpen(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]"
                        onClick={() => handleAddCustomer()}
                      >
                        {custInfo ? 'Update' : 'Add'} customer
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Transition.Root show={active} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setActive}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-[#c1c9d2b3] opacity-100" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm">
                  <div>
                    <div className="font-semibold p-[16px_20px] pb-0 text-base text-gray-900">
                      Remove billing address
                    </div>
                    <p className="p-[0_20px] mt-2 text-gray-900 text-sm">
                      This removes all the billing details associated with this
                      customer.
                    </p>
                    <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                      <button
                        className="border-[2px] h-[30px] rounded-[6px] border-[#ebeef1] text-[14px] font-semibold p-[0_8px]"
                        onClick={() => setActive(false)}
                      >
                        Cancel
                      </button>
                      {removeData === "1" && (
                        <button
                          className="border-[2px] h-[30px] rounded-[6px] border-[#df1b41] text-white bg-[#df1b41] text-[14px] font-semibold p-[0_8px]"
                          onClick={() => {
                            setActive(false);
                            setSelected(Countries[0]);
                          }}
                        >
                          Remove
                        </button>
                      )}
                      {removeData === "2" && (
                        <button
                          className="border-[2px] h-[30px] rounded-[6px] border-[#df1b41] text-white bg-[#df1b41] text-[14px] font-semibold p-[0_8px]"
                          onClick={() => {
                            setActive(false);
                            setSelected2(Countries[0]);
                          }}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
      <Transition.Root show={confirm} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setConfirm}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-[#c1c9d2b3] opacity-100" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white p-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[496px] sm:p-[38px]">
                  <div>
                    <p>
                      To access certain parts of the Dashboard, please confirm
                      your password.
                    </p>
                    <div className="flex flex-col gap-2 mt-7">
                      <label className="font-medium text-sm text-[#1a1b25]">
                        Confirm password
                      </label>
                      <input
                        name="email"
                        type="password"
                        onChange={(e) => setConfirmPwd(e.target.value)}
                        className="border-[1px] border-gray-300 focus:outline-none text-gray-600 px-[10px] py-[7px] rounded-md"
                      />
                      <div className="mt-4">
                        <button
                          onClick={confirmPassword}
                          className="text-center px-3 sm:py-3 py-2 rounded-md bg-[#5469d4] w-full text-base font-medium text-white"
                        >
                          Continue
                        </button>
                        <button
                          className="text-center px-3 sm:py-3 py-2 mt-5 text-[#5469d4] w-full text-sm font-medium"
                          onClick={() => setConfirm(false)}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default AddCustomerModel;
